<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  },
  created(){
    
  },
  mounted(){
    if(this.isMobile()) {
      window.location.href='https://m.risensafe.com/'
    }
  },
  methods:{
   isMobile() {
      const sUserAgent = navigator.userAgent.toLowerCase();
      const bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      const bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      const bIsMidp = sUserAgent.match(/midp/i) == "midp";
      const bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      const bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      const bIsAndroid = sUserAgent.match(/android/i) == "android";
      const bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      const bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      const flag = bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM ? true : false // true==phone  false==pc
      return flag
    }
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
  font-family:PingFangSC-Medium,PingFang SC;
}
#app {
  font-family: 'Microsoft YaHei', Helvetica, 'Avenir',Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  font-size: 12px;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue